import { withRouter } from 'react-router-dom'
import { UnansweredQuestions } from './UnansweredQuestions'

export default withRouter(UnansweredQuestions)
